const AlertIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 0.5C7.76142 0.5 10 2.73858 10 5.5C10 8.26142 7.76142 10.5 5 10.5C2.23858 10.5 0 8.26142 0 5.5C8.0532e-08 2.73858 2.23858 0.5 5 0.5ZM5 1.40918C2.74065 1.40918 0.90918 3.24065 0.90918 5.5C0.90918 7.75935 2.74065 9.59082 5 9.59082C7.25935 9.59082 9.09082 7.75935 9.09082 5.5C9.09082 3.24065 7.25935 1.40918 5 1.40918ZM5.05078 6.86621C5.27998 6.88949 5.45898 7.08302 5.45898 7.31836C5.45889 7.55362 5.27992 7.74723 5.05078 7.77051L5.00488 7.77246H5C4.74902 7.77246 4.546 7.56931 4.5459 7.31836C4.5459 7.06732 4.74896 6.86328 5 6.86328H5.00488L5.05078 6.86621ZM5 3.22754C5.25096 3.22756 5.454 3.4307 5.4541 3.68164V5.5C5.4541 5.75103 5.25102 5.95408 5 5.9541C4.74896 5.9541 4.5459 5.75104 4.5459 5.5V3.68164C4.546 3.43069 4.74903 3.22754 5 3.22754Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AlertIcon;
